"use strict";
exports.__esModule = true;
exports.verify = exports.sign = void 0;
var sign_1 = require("./lib/sign");
exports.sign = sign_1.sign;
var verify_1 = require("./lib/verify");
exports.verify = verify_1.verify;
var Web3Sign = {
    sign: sign_1.sign,
    verify: verify_1.verify
};
exports["default"] = Web3Sign;
